import { useMutation } from "@tanstack/react-query";
import { message } from "antd";

import { type DishIssueStatus } from "@fitness-app/data-models/entities/DishIssue";

import { useUserRole } from "~/hooks/trainer/useUserRole";
import { supabase } from "~/store/initializeStore";

type UpdateDishIssuePayload = {
  id: string;
  status: DishIssueStatus;
  reason?: string;
  metadata?: Record<string, string | boolean | number | object>;
};

export const useUpdateDishIssue = (showToast = true, successMessage = "Status został zgłoszenia zaktualizowany") => {
  const { userId } = useUserRole();

  const mutation = useMutation({
    async mutationFn(payload: UpdateDishIssuePayload) {
      const { error } = await supabase
        .from("dish_issue")
        .update({
          ...payload,
          solvedBy: userId,
          updatedAt: new Date().toISOString(),
        })
        .eq("id", payload.id);

      if (error) {
        throw new Error(error.message);
      }
    },
    onSuccess: () => {
      if (showToast) {
        message.success(successMessage);
      }
    },
    onError: (error: Error) => {
      if (showToast) {
        message.error(error.message);
      }
    },
  });

  return {
    updateIssue: mutation.mutateAsync,
    isUpdating: mutation.isLoading,
  };
};
